import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class WorkstationDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default WorkstationDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/workstationChafari/DeviceSetup.js